'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

/**
 * Data source types.
 *
 * @export
 * @enum {string}
 */
var DataSourceType = /*#__PURE__*/function (DataSourceType) {
  DataSourceType["None"] = "";
  DataSourceType["File"] = "file";
  DataSourceType["S3"] = "s3";
  DataSourceType["GoogleCloudStorage"] = "gcs";
  DataSourceType["Kafka"] = "kafka";
  DataSourceType["AzureBlobStorage"] = "abs";
  DataSourceType["BigQuery"] = "bq";
  DataSourceType["DeltaLake"] = "deltaLake";
  DataSourceType["Spark"] = "spark";
  DataSourceType["Iceberg"] = "iceberg";
  DataSourceType["Snowflake"] = "snowflake";
  DataSourceType["Postgres"] = "postgres";
  return DataSourceType;
}({});

/**
 * Data source.
 *
 * @export
 * @interface DataSource
 */

exports.DataSourceType = DataSourceType;
